import { AuditLogGetData } from '~/api/def/endpoints/auditLogEndpoint';

export const determineCategory = (auditLog: AuditLogGetData): string => {
  if (auditLog.fundId) return 'Fund';

  if (auditLog.portfolioCompanyId) return 'Portfolio Company';

  return '';
};
